import { createHead } from '@unhead/vue'
import type { App } from 'vue'

const head = createHead();

export default function (app: App) {
  app.use(head)
}
